export default "__VITE_ASSET__Ck48_6F7__"